exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show_total_profit{\r\n    text-align: right;     \r\n    font-weight: bold;\r\n}\r\n.total_profit{\r\n    text-align: right;     \r\n    font-weight: bold;\r\n}\r\n.timeSearch{\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n}\r\n.checkboxFilterTrade {\r\n    float: right;\r\n    min-width: 388px;\r\n}\r\n.checkboxFilterTrade label {\r\n    padding-left: 7px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/trade-history/trade-history.component.css
// module id = ../../../../../src/app/_components/trade-history/trade-history.component.css
// module chunks = main